
import filters from "@/filters";
import { Component, Vue } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import { AxiosResponse } from "axios";
import { setToken } from "@/functions/token.function";
import { isEmail } from "@/functions/global.function";
import { param } from "jquery";
import _ from "lodash";
import toast from "@/functions/toast.function";
import { course } from "@/store/course";

@Component({
  components: {},
  filters,
})
export default class Login extends Vue {
  @State("user", { namespace: "auth" })
  private user: any;
  @Action("getSelf", { namespace: "auth" })
  private getSelf: any;
  @Action("login", { namespace: "auth" })
  private login: any;
  @Action("loginWithGoogle", { namespace: "auth" })
  private loginWithGoogle: any;
  @Action("sendLoginOtp", { namespace: "auth" })
  private sendLoginOtp: any;

  private email = "";
  private password = "";
  private emailError = "";
  private passwordError = "";
  private show = false;

  private googleClientID: any = process.env.VUE_APP_GOOGLE_CLIENT_ID;

  private togglePassword() {
    this.show = !this.show;
    const password = document.getElementById("password");
    password?.setAttribute("type", this.show ? "text" : "password");
    password?.focus();
  }

  private resetError() {
    this.emailError = "";
    this.passwordError = "";
  }

  get showWarn() {
    return this.$route.query?.course || this.$route.query?.bundle;
  }

  private submit() {
    this.resetError();
    if (!this.email) {
      this.emailError = "The email field is required.";
      return false;
    }
    if (!isEmail(this.email)) {
      this.emailError = "The email field must be a valid email address.";
      return false;
    }

    // this.sendOtp({
    //   params: {
    //     email: this.email,
    //   },
    //   success: (response: AxiosResponse) => {
    //     this.$router.push({
    //       name: "verify-email",
    //       query: { email: this.email, redirect: 'login' },
    //     });
    //   },
    //   error: (err: any) => {
    //     console.error('Send OTP failed:', err);
    //     if (err.response && err.response.data && err.response.data.message) {
    //       this.emailError = err.response.data.message;
    //     } else {
    //       this.emailError = 'Failed to send OTP. Please try again later.';
    //     }
    //   }
    // });

    // if (!this.password) {
    //   this.passwordError = "The password field is required.";
    //   return false;
    // }
    this.login({
      params: {
        email: this.email,
        // password: this.password,
      },
      success: (response: AxiosResponse) => {
        this.sendLoginOtp({
          params: {
            email: this.email,
          },
          success: (res: AxiosResponse) => {
            this.$router.push({
              name: "verify-email",
              query: { redirect: "login", email: this.email, course: this.$route.query?.course, bundle: this.$route.query?.bundle },
            });
          },
          error: (err: any) => {
            console.error('Send OTP failed:', err);
            if (err.response && err.response.data && err.response.data.message) {
              this.emailError = err.response.data.message;
            } else {
              this.emailError = 'Failed to send OTP. Please try again later.';
            }
          }
        });
        // setToken(response.data.data.token);
        // this.getSelf().then(() => {
        //   const courseSlug = this.$route.query?.course;
        //   const bundleSlug = this.$route.query?.bundle;
        //   if (bundleSlug && typeof bundleSlug === 'string') {
        //     this.$router.push({
        //       name: "bundle-course-detail",
        //       params: { slug: bundleSlug },
        //     });
        //   } else if (courseSlug && typeof courseSlug === 'string') {
        //     this.$router.push({
        //       name: "course-detail",
        //       params: { slug: courseSlug },
        //     });
        //   } else {
        //     this.$router.push({
        //       name: "home",
        //     });
        //   }
        // });
      },
    });
  }

  private mounted() {
    const googleClientId = process.env.VUE_APP_GOOGLE_CLIENT_ID;
    if (googleClientId) {
      this.initGoogleAuth(googleClientId);
    }
  }

  private initGoogleAuth(clientId: string) {
    if (typeof (window as any).google !== 'undefined') {
      // Initialize Google Identity Services
      (window as any).google.accounts.id.initialize({
        client_id: clientId,
        callback: this.handleCredentialResponse,
        auto_prompt: true,
      });

      // Render the sign-in button
      (window as any).google.accounts.id.renderButton(
        document.getElementById('googleSignInContainer'),
        {
          type: 'icon',
          shape: 'circle',
          theme: 'filled_blue',
          size: 'large',
          width: 40,
        }
      );
    } else {
      setTimeout(() => {
        this.initGoogleAuth(clientId);
      }, 100);
    }
  }

  private handleCredentialResponse(response: any) {
    try {
      const payload = JSON.parse(atob(response.credential.split('.')[1]));
    } catch (error) {
      console.error('Error decoding JWT:', error);
    }

    // TODO: This is the only part you need to send to your backend
    // The backend should then verify this credential with Google
    this.loginWithGoogle({
      params: {
        id_token: response.credential
      },
      success: (res: AxiosResponse) => {
        setToken(res.data.data.token);
        this.getSelf({
          success: () => {
            const courseSlug = this.$route.query?.course;
            if (courseSlug && typeof courseSlug === 'string') {
              this.$router.push({
                name: "course-detail",
                params: { slug: courseSlug },
              });
            } else {
              this.$router.push({
                name: "home",
              });
            }
          },
          error: (err: any) => {
            console.error('Get self failed:', err);
            // Optionally show an error message to the user
            toast.error('Failed to retrieve user information.');
          }
        });
        // setToken(response.data.data.token);
        // this.getSelf().then(() => {
        //   const courseSlug = this.$route.query?.course;
        //   const bundleSlug = this.$route.query?.bundle;
        //   if (bundleSlug && typeof bundleSlug === 'string') {
        //     this.$router.push({
        //       name: "bundle-course-detail",
        //       params: { slug: bundleSlug },
        //     });
        //   } else if (courseSlug && typeof courseSlug === 'string') {
        //     this.$router.push({
        //       name: "course-detail",
        //       params: { slug: courseSlug },
        //     });
        //   } else {
        //     this.$router.push({
        //       name: "home",
        //     });
        //   }
        // });
      },
      error: (err: any) => {
        console.error('Login with Google failed:', err);
        // Optionally show an error message to the user
      }
    });
  }
}
